export function setCookie(cookieName: string, cookieValue: string, path = '/', expires?) {
  if (expires == null) {
    expires = new Date();
    expires.setYear(2100);
    expires = expires.toUTCString();
  }

  document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=${path}`;
}
